import { extractLogicalUnitCode } from './U2000GetUserDocPath';

/**
 * BL-0429 — Mode liste d'une UL : pathname dont le dernier segment significatif est le code UL
 * (ex. `/U3121`, `/U3121/`). Tout sous-chemin (`/create`, `/:id`, nested) = formulaire.
 */
export function u2000IsLogicalUnitListPath(pathname: string): boolean {
  if (!pathname) {
    return false;
  }
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) {
    return false;
  }
  const luIndex = segments.findIndex((segment) => extractLogicalUnitCode(segment) != null);
  if (luIndex < 0) {
    return false;
  }
  return luIndex === segments.length - 1;
}
